module.exports = __webpack_public_path__ + "img/11.204dacc2.jpg";